import { handleActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../actions';

const availServicesActions = actions.availServices;

export default handleActions(
  {
    [availServicesActions.getAsync.toString()]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(key => {
          avails = avails.setIn([hotelId, key, 'response'], avail.getIn([key, 'response']));
        });
      });
      return avails;
    },
    [availServicesActions.resetAvail.toString()]: (avails, { payload }) => {
      return avails.set(payload, Map());
    }
  },
  Map()
);
